/* tslint:disable */
/* eslint-disable */
/**
 * Main data new API
 * Auto-generated openapi scheme for main-data-new API
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    Coordinate,
    CoordinateFromJSON,
    CoordinateFromJSONTyped,
    CoordinateToJSON,
} from './';

/**
 * 
 * @export
 * @interface PositionListP44
 */
export interface PositionListP44 {
    /**
     * 
     * @type {number}
     * @memberof PositionListP44
     */
    deviceId: number;
    /**
     * 
     * @type {string}
     * @memberof PositionListP44
     */
    registrationNumber: string;
    /**
     * 
     * @type {Coordinate}
     * @memberof PositionListP44
     */
    coordinate: Coordinate;
    /**
     * 
     * @type {string}
     * @memberof PositionListP44
     */
    ignitionState: PositionListP44IgnitionStateEnum;
    /**
     * 
     * @type {Date}
     * @memberof PositionListP44
     */
    dateTime: Date;
    /**
     * 
     * @type {number}
     * @memberof PositionListP44
     */
    heading?: number;
    /**
     * 
     * @type {number}
     * @memberof PositionListP44
     */
    speed?: number;
}

export function PositionListP44FromJSON(json: any): PositionListP44 {
    return PositionListP44FromJSONTyped(json, false);
}

export function PositionListP44FromJSONTyped(json: any, ignoreDiscriminator: boolean): PositionListP44 {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'deviceId': json['deviceId'],
        'registrationNumber': json['registrationNumber'],
        'coordinate': CoordinateFromJSON(json['coordinate']),
        'ignitionState': json['ignitionState'],
        'dateTime': json['dateTime'],
        'heading': !exists(json, 'heading') ? undefined : json['heading'],
        'speed': !exists(json, 'speed') ? undefined : json['speed'],
    };
}

export function PositionListP44ToJSON(value?: PositionListP44 | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'deviceId': value.deviceId,
        'registrationNumber': value.registrationNumber,
        'coordinate': CoordinateToJSON(value.coordinate),
        'ignitionState': value.ignitionState,
        'dateTime': value.dateTime,
        'heading': value.heading,
        'speed': value.speed,
    };
}

/**
* @export
* @enum {string}
*/
export enum PositionListP44IgnitionStateEnum {
    ON = 'ON',
    OFF = 'OFF'
}


